/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'fax': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.938 8.288l2.997 2.665a1.126 1.126 0 01.378.84V23.25h-19.5a1.126 1.126 0 01-1.126-1.125V7.875A1.126 1.126 0 012.813 6.75h3.376v-6h9.31l3.44 3.44v4.098zM3.188 21.75h3V8.25h-3v13.5zm11.689-19.5h-.44v3h3v-.44l-2.56-2.56zm-1.94 0h-5.25v7.875h9.75V6.75h-4.5v-4.5zm-5.25 19.5h13.125v-9.788l-1.875-1.667v1.33H7.688V21.75zm3.75-5.625h-1.5v1.5h1.5v-1.5zm1.5 0h1.5v1.5h-1.5v-1.5zm-1.5 3h-1.5v1.5h1.5v-1.5zm1.5 0h1.5v1.5h-1.5v-1.5zm4.5-3h-1.5v1.5h1.5v-1.5zm-1.5 3h1.5v1.5h-1.5v-1.5zm1.5-6h-7.5v1.5h7.5v-1.5z" _fill="#000"/>'
  }
})
